import { render, staticRenderFns } from "./500.vue?vue&type=template&id=a65c7134&scoped=true"
import script from "./500.vue?vue&type=script&lang=js"
export * from "./500.vue?vue&type=script&lang=js"
import style0 from "./500.vue?vue&type=style&index=0&id=a65c7134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65c7134",
  null
  
)

export default component.exports